import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { StyledButton } from '../AddToCartBtn/AddToCartBtnStyles';
import { getGraduationYearSelectOptions } from '../../Utils/FormUtils';

import { RadioButton, TextInput, SelectInput } from './FieldComponents';

import { StyledRadioGroup, StyledLabel } from './FormStyles';

var _ref2 = React.createElement(Field, {
  component: RadioButton,
  radioValue: 'email',
  name: 'contactMethod',
  label: 'Email me'
});

var _ref3 = React.createElement(Field, {
  component: RadioButton,
  radioValue: 'sms',
  name: 'contactMethod',
  label: 'Text me'
});

export var ContactMethodRadioGroup = function ContactMethodRadioGroup(_ref) {
  var hideLabel = _ref.hideLabel,
      align = _ref.align,
      isTouchDevice = _ref.isTouchDevice,
      setFieldValue = _ref.setFieldValue;

  useEffect(function () {
    setFieldValue('contactMethod', isTouchDevice ? 'sms' : 'email');
  }, [isTouchDevice, setFieldValue]);
  return React.createElement(
    Fragment,
    null,
    !hideLabel && React.createElement(
      StyledLabel,
      { style: { marginBottom: 5 } },
      'Contact Method'
    ),
    React.createElement(
      StyledRadioGroup,
      { align: align, isTouchDevice: isTouchDevice },
      _ref2,
      _ref3
    )
  );
};

ContactMethodRadioGroup.propTypes = {
  hideLabel: PropTypes.bool.isRequired,
  align: PropTypes.string.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isTouchDevice: PropTypes.bool.isRequired
};
ContactMethodRadioGroup.defaultProps = {
  align: 'flex-start',
  hideLabel: false
};

export var EmailField = function EmailField(_ref4) {
  var hideLabel = _ref4.hideLabel;
  return React.createElement(Field, {
    component: TextInput,
    type: 'email',
    name: 'email',
    label: 'Email',
    hideLabel: hideLabel,
    placeholder: 'Enter your email address'
  });
};

EmailField.propTypes = {
  hideLabel: PropTypes.bool,
  autoFocus: PropTypes.bool
};

export var PhoneField = function PhoneField(_ref5) {
  var hideLabel = _ref5.hideLabel;
  return React.createElement(Field, {
    component: TextInput,
    type: 'phone',
    name: 'phone',
    label: 'Phone Number',
    placeholder: '333-333-3333',
    hideLabel: hideLabel
  });
};

PhoneField.propTypes = {
  hideLabel: PropTypes.bool
};

export var GenderSelect = function GenderSelect() {
  return React.createElement(Field, {
    component: SelectInput,
    name: 'gender',
    label: 'Gender',
    options: [{ value: '', label: 'Select gender', disabled: true }, { value: 'female', label: 'Female' }, { value: 'male', label: 'Male' }, { value: 'other', label: 'Other' }, { value: 'na', label: 'Prefer not to say' }]
  });
};

export var PersonSelect = function PersonSelect() {
  return React.createElement(Field, {
    component: SelectInput,
    name: 'person',
    label: 'I am a ...',
    options: [{ value: '', label: 'Select type', disabled: true }, { value: 'student', label: 'Student' }, { value: 'parent', label: 'Parent' }, { value: 'graduate', label: 'College graduate' }, { value: 'na', label: 'Prefer not to say' }]
  });
};

export var GraduationYearSelect = function GraduationYearSelect(_ref6) {
  var formValues = _ref6.formValues;

  var _useState = useState('When do you graduate college?'),
      _useState2 = _slicedToArray(_useState, 2),
      label = _useState2[0],
      setLabel = _useState2[1];

  useEffect(function () {
    if (formValues.person === 'parent') {
      setLabel('When does your child graduate college?');
    } else if (formValues.person === 'graduate') {
      setLabel('When did you graduate college?');
    } else {
      setLabel('When do you graduate college?');
    }
  }, [formValues.person]);

  var options = getGraduationYearSelectOptions();

  return React.createElement(Field, {
    component: SelectInput,
    name: 'graduationYear',
    label: label,
    options: options
  });
};

GraduationYearSelect.propTypes = {
  formValues: PropTypes.object.isRequired
};

var _ref8 = React.createElement(LoadingSpinner, null);

export var SubmitButton = function SubmitButton(_ref7) {
  var isSubmitting = _ref7.isSubmitting,
      isValid = _ref7.isValid;

  return React.createElement(
    StyledButton,
    {
      className: 'data-capture-modal__submit-button',
      type: 'submit',
      'aria-disabled': isSubmitting || !isValid,
      useProductPageStyles: true,
      style: { margin: '15px 0' }
    },
    isSubmitting ? _ref8 : 'Sign Me Up'
  );
};

SubmitButton.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired
};

export var Error = function Error(_ref9) {
  var name = _ref9.name;

  return React.createElement(ErrorMessage, { name: name });
};

Error.propTypes = {
  name: PropTypes.string
};